
import { MultigameParams } from "../MultigameParams";
import { IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "../ResourceManager/ResourceManager";
import { SlotGameInitData } from "../SlotGameInitData";
import { BigSymbolFreegamesBonusFactory_2Screen } from "./Bonus/BigSymbolFreegames/BigSymbolFreegamesFactory_2Screen";
import { BigSymbolFreegamesBonusParams } from "./Bonus/BigSymbolFreegames/BigSymbolFreegamesParams";
import { BigSymbolSpinAndHoldBonusFactory_2Screen, IBigSymbolSpinAndHoldBonusFactory_2Screen } from "./Bonus/BigSymbolSpinAndHold/BigSymbolHoldAndSpin_2Screen";
import { Bonus } from "./Bonus/Bonus";
import { ExtendedSpinAndHoldFactory_2Screen } from "./Bonus/ExtendedSpinAndHold/ExtendedSpinAndHold_2Screen";
import { SlotBonus } from "./Bonus/SlotBonus";
import { SpinAndHoldBonusFactory_2Screen } from "./Bonus/SpinAndHold/SpinAndHoldBonus_2Screen";
import { ISpinAndHoldBonusFactory } from "./Bonus/SpinAndHold/SpinAndHoldFactory";
import { SpinAndHoldParams } from "./Bonus/SpinAndHold/SpinAndHoldParams";
import { FreegameBonusFactory, FreegameBonusParams } from "./FreegameBonus/FreegameBonus";
import { FreeGameBonusFactory_2Screen, IFreegameBonusFactory_2Screen } from "./FreegameBonus/FreegameBonus_2Screen";
import { PickBonusFactory } from "./PickBonus/PickBonus";
import { PickBonusParams } from "./PickBonus/PickBonusParams";
import { PickBonusFactory_2Screen } from "./PickBonus/PickBonus_2Screen";
import { SlotGameState } from "./SlotGameState";
import { SlotGameType1 } from "./SlotGameType1";
import { MarkersInfoColors } from "./WinLineInfoMarkers";
import { ChangeSpeedFactor, availableSpinParams } from "../SpeedManager";
import { BigSymbolFreegamesCommonConfiguration, ExtendedSpinAndHoldCommonConfiguration, ISimpleBonusAction, SpinAndHoldCommonConfiguration } from "../api";

export class SlotGameType1_2Screen extends SlotGameType1
{
	
	
	//ADD FREEGAME 2 SCREEN
	protected freegameBonusFactory_2Screen: IFreegameBonusFactory_2Screen = new FreeGameBonusFactory_2Screen();
	
	//USE FOR 2 SCREEN
	protected pickBonusFactory_2Screen: PickBonusFactory = new PickBonusFactory_2Screen();
	
	//protected panel: Panel  = null;
	//Spin And Hold Bonus for 2 Screen
	protected spinAndHoldBonusFactory_2Screen: ISpinAndHoldBonusFactory = new SpinAndHoldBonusFactory_2Screen();
	//BIG SYMBOL FREE GAME SPIN AND HOLD FACTORY
	protected bigSymbolSpinAndHoldBonusFactory_2Screen: IBigSymbolSpinAndHoldBonusFactory_2Screen = new BigSymbolSpinAndHoldBonusFactory_2Screen();
	//BIG SYMBOL FREE GAME 
	protected bigSymbolFreegameBonusFactory_2Screen: BigSymbolFreegamesBonusFactory_2Screen = new BigSymbolFreegamesBonusFactory_2Screen();

	protected extendedSpinAndHoldBonusFactory_2Screen: ExtendedSpinAndHoldFactory_2Screen = new ExtendedSpinAndHoldFactory_2Screen();

	public constructor(multigameParams: MultigameParams, initData: SlotGameInitData, gameName: string) 
	{
		super(multigameParams,initData, gameName);
		//this.panel = new PanelPyramid(this.systemContext, this.resid, "./", this.audio);

	}

	// protected override AudioPrepare(resourceManager: IWriteOnlyResourceManager): void {
	// 	super.AudioPrepare(resourceManager);
	// 	//this.audio.AddTrack(new Track(this.commonpath + "resources/Dragontracks/pickbonusDragonLink" + Settings.audioFormat, this.resid.ScopedResourceName("pickbonus")));
		
	// }

	

	// protected override GroowReel(reelWindowElement: HTMLElement,zoomFactor: number,scaleAnim:any,reelElement: HTMLElement)
	// {
	// 	zoomFactor=1.04;
	// 	reelWindowElement.style.transformOrigin = "top";
	// 	scaleAnim = TweenLite.to(reelWindowElement, 0.5, {scaleY: zoomFactor/*, backgroundColor: newBackgroundAnticipation.toRgba()*/});
	// 	TweenLite.to(reelElement, 0.5, {scaleX: zoomFactor});
	// }

	// protected override GroowReelReset(reelWindowElement: HTMLElement,scaleAnim:any,reelElement: HTMLElement,oldZIndex:string)
	// {
	// 	TweenLite.to(reelElement, 0.5, {scaleX: 1});
	// 	scaleAnim = TweenLite.to(reelWindowElement, 0.5, {scaleY: 1, /*backgroundColor: originalBackgroundAnticipation.toRgba(),*/
	// 		onComplete: () => 
	// 		{
	// 				reelWindowElement.style.zIndex = oldZIndex;
	// 		}});
	// }


	



	protected override async PickBonusPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void>
	{
		if (loadingStage != LoadingStage.Games) return;

		let pickBonusparams: PickBonusParams = 
		{
			systemContext: this.systemContext,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol,
			screenProtocolScope: this.screenProtocolScope,
			gameBonusResourcesBasePath: this.basepath + "resources/PickBonus/",
			commonBonusResourcesBasePath: this.commonpath + "resources/PickBonus/",
			bonusConfiguration: this.initData.BonusConfiguration.PickBonus,
			pickElementFactory: this.pickBonusFactory,
			screenSize: this.multigameParams.viewSize,
			panel: this.panel,
			audio: this.audio,
			translator: this.translator,
			robotPlay: this.robotPlay,
			slotGameMeta: this.initData.Meta,
			clientState: this.clientState,
			jackpotRequired: this.multigameParams.jackpotRequired,
			bonusAutoplay: this.multigameParams.backendSettings.GetBool("play.bonusautoplay", true)
		};
			
		//USE FOR 2 SCREEN
		
		let pickBonus: SlotBonus = this.pickBonusFactory_2Screen.CreatePickBonus(this.name, pickBonusparams);

		//change state when bonus is finished 
		//after bonus comes collect
		pickBonus.SetBonusFinishedCallback(() => {
			this.OnBonusFinished();
		});
		pickBonus.SetBonusFinishedCallback(() => this.stateMachine.ChangeState(SlotGameState.BigWinTotal));
		pickBonus.SetBonusPanelRequiredCallback((required: boolean) => {
			if (required)
				this.panel.Show();
			else
				this.panel.Hide();
		});

		await pickBonus.PrepareResources(loadingStage, resourceManager);

		this.bonusList.set(Bonus.PickBonus, pickBonus);
	}

	

	protected override async FreegamesPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {
		if (loadingStage == LoadingStage.GamesPreload)
		{
			let fgparams: FreegameBonusParams =
			{
				systemContext: this.systemContext,
				resid: this.resid,
				logGroup: this.logGroup,
				screenProtocol: this.screenProtocol,
				screenProtocolScope: this.screenProtocolScope,
				gameResourcesBasePath: this.basepath,
				gameBonusResourcesBasePath: this.basepath + "resources/FreeGameBonus/",
				commonBonusResourcesBasePath: this.commonpath + "resources/FreeGameBonus/",
				screenSize: this.multigameParams.viewSize,
				windowSymbolSize: this.windowSymbolSize,
				windowRectangle: this.windowRectangle,
				symbolSpriteAnims: this.symbolSpriteAnims,
				symbolSpriteAnimsByName: this.symbolSpriteAnimsByName,
				playlines: this.playlines,
				// reelSet: this.initData.BonusConfiguration.FreeGameBonus.ReelSet,
				startPositions: this.initData.BonusConfiguration.FreeGameBonus.ReelSet.map(r => 0),
				panel: this.panel,
				audio: this.audio,
				lines: this.selectedBet.Lines,
				denom: this.selectedBet.Denom.InCents, //this.denoms[this.selectedDenomIndex],
				bonusConfiguration: this.initData.BonusConfiguration.FreeGameBonus,
				pickElementFactory: this.freegameBonusFactory,
				// TODO duplicate with lines
				linesPlayed: this.selectedBet.Lines, // this.lines[this.selectedLineIndex],

				clientState: this.clientState,
				translator: this.translator,
				robotPlay: this.robotPlay,
				slotGameMeta: this.initData.Meta,
				slotGameInitData: this.initData,
				slotGame: this,
				availableSymbols: this.symbols,
				availableSymbolsMap: this.symbolsMap,
				jackpotRequired: this.multigameParams.jackpotRequired,
				color: this.color,
				bonusList: this.bonusList,
				pixiSpritesByName: this.pixiSpritesByName,
				spinnableReelsParams: this.spinnableReelsParams,
				reelBackgroundTexture: this.reelBackgroundTexture,
				reelBackgroundMaskTexture: this.reelBackgroundMaskTexture,
				colorLineMarkers: this.colorLineMarkers,
				initData: this.initData,
				skinAttachmentFillingPotFeature: this.skinAttachmentFillingPotFeature,
				reelAnimationParams: availableSpinParams[this.speedManager.GetDefaultReelSpeedType()],
				winAnimationSpeedFactor: ChangeSpeedFactor[this.speedManager.GetDefaultCelebrationType()],
				gameConfig : this.gameConfig,
				backendSettings: this.multigameParams.backendSettings,
			};

			let freegameBonus: SlotBonus = this.freegameBonusFactory_2Screen.CreateFreegameBonus_2Screens(this.gameName, fgparams);
			// after bonus comes collect
			freegameBonus.SetBonusFinishedCallback(() => {
				//this.stateMachine.ChangeState(SlotGameState.BigWinTotal);
				this.OnBonusFinished();
			});

			freegameBonus.SetBonusRunFinishedCallback((run: ISimpleBonusAction[]) => {
				this.OnBonusRunFinish(run);
			})
			freegameBonus.SetBonusPanelRequiredCallback((required: boolean) => {
				if (required)
					this.panel.Show();
				else
					this.panel.Hide();
			});
			this.bonusList.set(Bonus.FreeGameBonus, freegameBonus);
		}

		let freegameBonus = this.bonusList.get(Bonus.FreeGameBonus);
		await freegameBonus.PrepareResources(loadingStage, resourceManager);
	}


	protected override async SpinAndHoldPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {

		if (loadingStage != LoadingStage.Games) return;

		let bonusParams: SpinAndHoldParams = 
		{
			systemContext: this.systemContext,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol,
			screenProtocolScope: this.screenProtocolScope,
			gamepath: this.basepath,
			commonpath: this.commonpath,
			gameBonusResourcesBasePath: this.basepath + "resources/HoldAndSpin/",
			commonBonusResourcesBasePath: this.commonpath + "resources/HoldAndSpin/",
			screenSize: this.multigameParams.viewSize,
			// windowSymbolSize: this.windowSymbolSize,
			// windowRectangle: this.windowRectangle,
			symbolSpriteAnims: this.symbolSpriteAnims,
			symbolSpriteAnimsByName: this.symbolSpriteAnimsByName,
			playlines: this.playlines,
			symbols: this.symbols,
			spinnableReelsParams: this.spinnableReelsParams,
			//reelSet: <number[][]>this.initData.bonusConfiguration["SpinAndHoldBonus"].ReelSet,
			//startPositions: [0, 0, 0, 0, 0],
			panel: this.panel,
			audio: this.audio,
			// TODO remove
			lines: this.selectedBet.Lines,
			
			// TODO remove?
			denom: this.selectedBet.Denom.InCents,
			
			// TODO remove?
			linesPlayed: this.selectedBet.Lines,
			clientState: this.clientState,
			translator: this.translator,
			robotPlay: this.robotPlay,
			slotGameMeta: this.initData.Meta,
			slotGameInitData: this.initData,
			slotGame: this,
			color: this.color,
			jackpotEnable : this.multigameParams.jackpotRequired,
			bonusAutoplay: this.multigameParams.backendSettings.GetBool("play.bonusautoplay", true),
			pixiSpritesByName : this.pixiSpritesByName,
			reelAnimationParams: availableSpinParams[this.speedManager.GetDefaultReelSpeedType()],
			FpsFactor: ChangeSpeedFactor[this.speedManager.GetDefaultCelebrationType()],
			gameConfig : this.gameConfig,
		};
		
		let bonusConfig: SpinAndHoldCommonConfiguration = this.initData.BonusConfiguration.SpinAndHold;

		let spinAndHoldBonus: SlotBonus = this.spinAndHoldBonusFactory_2Screen.CreateSpinAndHoldBonus(this.gameName, bonusParams, bonusConfig);

		// after bonus comes collect
		//spinAndHoldBonus.SetBonusFinishedCallback(() => this.stateMachine.ChangeState(SlotGameState.BigWinTotal));
		spinAndHoldBonus.SetBonusFinishedCallback(() => {
			this.OnBonusFinished();
		});

		spinAndHoldBonus.SetBonusRunFinishedCallback((run: ISimpleBonusAction[]) => {
			this.OnBonusRunFinish(run);
		});

		spinAndHoldBonus.SetBonusPanelRequiredCallback((required: boolean) => {
			if (required)
				this.panel.Show();
			else
				this.panel.Hide();
		});

		await spinAndHoldBonus.PrepareResources(loadingStage, resourceManager);

		this.bonusList.set(Bonus.SpinAndHold,spinAndHoldBonus);
	}


	protected override async BigSymbolFreegamesPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {

		if (loadingStage != LoadingStage.Games) return;

		let bonusParams: BigSymbolFreegamesBonusParams = 
		{
			systemContext: this.systemContext,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol,
			screenProtocolScope: this.screenProtocolScope,
			commonPath: this.commonpath,
			gamePath: this.basepath,
			screenSize: this.multigameParams.viewSize,
			playWindow: this.windowSymbolSize,
			windowRectangle: this.windowRectangle,
			symbolSpriteAnims: this.symbolSpriteAnims,
			symbolSpriteAnimsByName: this.symbolSpriteAnimsByName,
			playlines: this.playlines,
			symbols: this.symbols,
			spinnableReelsParams: this.spinnableReelsParams,
			//reelSet: <number[][]>this.initData.bonusConfiguration["SpinAndHoldBonus"].ReelSet,
			//startPositions: [0, 0, 0, 0, 0],
			panel: this.panel,
			audio: this.audio,

			// TODO remove
			lines: this.selectedBet.Lines,

			// TODO remove?
			denom: this.selectedBet.Denom.InCents,

			// TODO remove?
			linesPlayed: this.selectedBet.Lines,

			clientState: this.clientState,
			translator: this.translator,
			robotPlay: this.robotPlay,
			slotGameMeta: this.initData.Meta,
			slotGameInitData: this.initData,
			slotGame: this,

			color: this.color,
			jackpotEnable: this.multigameParams.jackpotRequired,
			bonusAutoplay: this.multigameParams.backendSettings.GetBool("play.bonusautoplay", true),
			bonusList: this.bonusList,
			reelAnimationParams: availableSpinParams[this.speedManager.GetDefaultReelSpeedType()],
			FpsFactor: ChangeSpeedFactor[this.speedManager.GetDefaultCelebrationType()],
			winAnimationFactor: ChangeSpeedFactor[this.speedManager.GetDefaultCelebrationType()],
			gameConfig: this.gameConfig,
		};

		let bonusConfig: BigSymbolFreegamesCommonConfiguration = this.initData.BonusConfiguration.BigSymbolFreegames;

		let bonus: SlotBonus = this.bigSymbolFreegameBonusFactory_2Screen.CreateSpinAndHoldBonus_2Screen(this.gameName, bonusParams, bonusConfig) as unknown as SlotBonus;

		// after bonus comes collect
		//spinAndHoldBonus.SetBonusFinishedCallback(() => this.stateMachine.ChangeState(SlotGameState.BigWinTotal));
		bonus.SetBonusFinishedCallback(() => {
			this.OnBonusFinished();
		});

		bonus.SetBonusRunFinishedCallback((run: ISimpleBonusAction[]) => {
			this.OnBonusRunFinish(run);
		});

		bonus.SetBonusPanelRequiredCallback((required: boolean) => {
			if (required)
				this.panel.Show();
			else
				this.panel.Hide();
		});

		await bonus.PrepareResources(loadingStage, resourceManager);

		this.bonusList.set(Bonus.BigSymbolFreegames, bonus);
	}

	protected override async BigSymbolSpinAndHoldPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {

		if (loadingStage != LoadingStage.Games) return;

		let bonusParams: SpinAndHoldParams = 
		{
			systemContext: this.systemContext,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol,
			screenProtocolScope: this.screenProtocolScope,
			gamepath: this.basepath,
			commonpath: this.commonpath,
			gameBonusResourcesBasePath: this.basepath + "resources/HoldAndSpin/",
			commonBonusResourcesBasePath: this.commonpath + "resources/HoldAndSpin/",
			screenSize: this.multigameParams.viewSize,
			// windowSymbolSize: this.windowSymbolSize,
			// windowRectangle: this.windowRectangle,
			symbolSpriteAnims: this.symbolSpriteAnims,
			symbolSpriteAnimsByName: this.symbolSpriteAnimsByName,
			playlines: this.playlines,
			symbols: this.symbols,
			spinnableReelsParams: this.spinnableReelsParams,
			//reelSet: <number[][]>this.initData.bonusConfiguration["SpinAndHoldBonus"].ReelSet,
			//startPositions: [0, 0, 0, 0, 0],
			panel: this.panel,
			audio: this.audio,
			// TODO remove
			lines: this.selectedBet.Lines,
			
			// TODO remove?
			denom: this.selectedBet.Denom.InCents,
			
			// TODO remove?
			linesPlayed: this.selectedBet.Lines,

			clientState: this.clientState,
			translator: this.translator,
			robotPlay: this.robotPlay,
			slotGameMeta: this.initData.Meta,
			slotGameInitData: this.initData,
			slotGame: this,

			color: this.color,
			jackpotEnable : this.multigameParams.jackpotRequired,
			bonusAutoplay: this.multigameParams.backendSettings.GetBool("play.bonusautoplay", true),
			pixiSpritesByName : this.pixiSpritesByName,
			reelAnimationParams: availableSpinParams[this.speedManager.GetDefaultReelSpeedType()],
			FpsFactor: ChangeSpeedFactor[this.speedManager.GetDefaultCelebrationType()],
			gameConfig : this.gameConfig,
		};
		
		let bonusConfig: SpinAndHoldCommonConfiguration = this.initData.BonusConfiguration.BigSymbolSpinAndHold;

		let bigFreeGamesBonus: SlotBonus = this.bigSymbolSpinAndHoldBonusFactory_2Screen.CreateBigSymbolSpinAndHoldBonus(this.gameName, bonusParams, bonusConfig);

		// after bonus comes collect
		//spinAndHoldBonus.SetBonusFinishedCallback(() => this.stateMachine.ChangeState(SlotGameState.BigWinTotal));
		bigFreeGamesBonus.SetBonusFinishedCallback(() => {
			this.OnBonusFinished();
		});

		bigFreeGamesBonus.SetBonusRunFinishedCallback((run: ISimpleBonusAction[]) => {
			this.OnBonusRunFinish(run);
		});

		bigFreeGamesBonus.SetBonusPanelRequiredCallback((required: boolean) => {
			if (required)
				this.panel.Show();
			else
				this.panel.Hide();
		});

		await bigFreeGamesBonus.PrepareResources(loadingStage, resourceManager);

		this.bonusList.set(Bonus.BigSymbolSpinAndHold, bigFreeGamesBonus);
	}

	protected override async ExtendedSpinAndHoldPrepare(loadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {

		if (loadingStage != LoadingStage.Games) return;

		let bonusParams: SpinAndHoldParams = 
		{
			systemContext: this.systemContext,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol,
			screenProtocolScope: this.screenProtocolScope,
			gamepath: this.basepath,
			commonpath: this.commonpath,
			gameBonusResourcesBasePath: this.basepath + "resources/ExtendedHoldAndSpin/",
			commonBonusResourcesBasePath: this.commonpath + "resources/ExtendedHoldAndSpin/",
			screenSize: this.multigameParams.viewSize,
			// windowSymbolSize: this.windowSymbolSize,
			// windowRectangle: this.windowRectangle,
			symbolSpriteAnims: this.symbolSpriteAnims,
			symbolSpriteAnimsByName: this.symbolSpriteAnimsByName,
			playlines: this.playlines,
			symbols: this.symbols,
			spinnableReelsParams: this.spinnableReelsParams,
			//reelSet: <number[][]>this.initData.bonusConfiguration["SpinAndHoldBonus"].ReelSet,
			//startPositions: [0, 0, 0, 0, 0],
			panel: this.panel,
			audio: this.audio,
			// TODO remove
			lines: this.selectedBet.Lines,
			
			// TODO remove?
			denom: this.selectedBet.Denom.InCents,
			
			// TODO remove?
			linesPlayed: this.selectedBet.Lines,
			clientState: this.clientState,
			translator: this.translator,
			robotPlay: this.robotPlay,
			slotGameMeta: this.initData.Meta,
			slotGameInitData: this.initData,
			slotGame: this,
			color: this.color,
			jackpotEnable : this.multigameParams.jackpotRequired,
			bonusAutoplay: this.multigameParams.backendSettings.GetBool("play.bonusautoplay", true),
			pixiSpritesByName : this.pixiSpritesByName,
			reelAnimationParams: availableSpinParams[this.speedManager.GetDefaultReelSpeedType()],
			FpsFactor: ChangeSpeedFactor[this.speedManager.GetDefaultCelebrationType()],
			gameConfig : this.gameConfig,
		};
		
		let bonusConfig: ExtendedSpinAndHoldCommonConfiguration = this.initData.BonusConfiguration.ExtendedSpinAndHold;

		let extendedSpinAndHoldBonus: SlotBonus = this.extendedSpinAndHoldBonusFactory_2Screen.CreateExtendedSpinAndHold_2Screen(this.gameName, bonusParams, bonusConfig);

		// after bonus comes collect
		extendedSpinAndHoldBonus.SetBonusFinishedCallback(() => {
			this.OnBonusFinished();
		});

		extendedSpinAndHoldBonus.SetBonusRunFinishedCallback((run: ISimpleBonusAction[]) => {
			this.OnBonusRunFinish(run);
		});

		extendedSpinAndHoldBonus.SetBonusPanelRequiredCallback((required: boolean) => {
			if (required)
				this.panel.Show();
			else
				this.panel.Hide();
		});

		await extendedSpinAndHoldBonus.PrepareResources(loadingStage, resourceManager);

		this.bonusList.set(Bonus.ExtendedSpinAndHold,extendedSpinAndHoldBonus);
	}

}
